<template>
	<div id="vx-col w-full mb-base" ref="popupContainer">
		<vs-popup
			:active.sync="showExportPopup"
			title="Êtes-vous sûr de vouloir exporter?"
		>
			<div class="w-full" style="display: flex; justify-content: center">
				<div class="flex m-8 w-1/3" style="justify-content: space-around">
					<vs-radio
						v-model="downloadWithMission"
						vs-name="downloadWithMission"
						:vs-value="false"
						>Contracts</vs-radio
					>
					<vs-radio
						v-model="downloadWithMission"
						vs-name="downloadWithMission"
						:vs-value="true"
						>Prestation</vs-radio
					>
				</div>
			</div>
			<div class="vx-row justify center">
				<vs-button
					id="downloadButton"
					color="primary"
					class="mt-2 w-1/5 vs-con-loading__container"
					@click="exportData(displayedContracts)"
					>Télécharger</vs-button
				>
			</div>
		</vs-popup>
		<FilterCard
			:refreshKey="1"
			:key="filterRefreshKey"
			:isOpen="true"
			:showListLength="displayedContracts.length"
			:filters="filtersTemplates"
			@filter="handleFilterEmits($event)"
			:actions="actionsTemplates"
			@action="handleActionEmits($event)"
			:onChangeEmit="true"
			@clearAll="resetAllFilter()"
		/>
		<!-- CONTRACT TABLE -->
		<vx-card class="mt-1" style="max-height: 79vh; overflow: auto">
			<div ref="contractTable">
				<div v-if="isLoading"><CircularLoader /></div>
				<ContractsTable
					v-else
					:refreshKey="refreshKey"
					:refreshLead="refreshLead"
					:contracts="displayedContracts"
					@delete-line="removeLine($event)"
					@modify-contract="modifyContract($event)"
					@display-contract="displayContractPopup($event)"
					@display-documents="displayDocumentPopup($event)"
				/>
			</div>
		</vx-card>
	</div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import FilterCard from "@/views/filters/FilterCard";
import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import ContractDocumentsListTable from "@/components/tables/ContractDocumentsListTable";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import purchasesMixin from "@/mixins/purchasesMixin";
import tasksMixin from "@/mixins/tasksMixin";
import store from "@/store/store";
import ContractsTable from "@/components/tables/ContractsTable";
import XLSX from "xlsx";
import VSyncSelect from "@/components/widgets/v-sync-select/VSyncSelect";
import CircularLoader from "../../components/widgets/loader/CircularLoader.vue";

// import { Contract } from "@/entities/Contract"

// import ContractInfoPopup from "@/components/popups/ContractInfoPopup";

export default {
	name: "ContractsDashboard",
	mixins: [dbFieldConvertor, utilsMixin, purchasesMixin, tasksMixin],
	components: {
		VSyncSelect,
		FilterCard,
		ContractsTable,
		CircularLoader,
	},
	data() {
		return {
			isLoading: false,
			refreshFilterList: [],
			refreshDataList: [],
			downloadWithMission: true,
			showExportPopup: false,
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			selectedContract: null,
			showContractPopup: false,
			showRouterPopup: true,
			accountmanagerFilter: "",
			commercialFilter: "",
			deliveryFilter: "",
			societyFilter: "",
			statusFilter: [],
			typeFilter: "",
			contractNumberFilter: "",
			accountmanagerFilterOn: false,
			commercialFilterOn: false,
			deliveryFilterOn: false,
			societyFilterOn: false,
			statusFilterOn: false,
			typeFilterOn: false,
			contractNumberFilterOn: false,
			displayedContractsFull: [],
			displayedContracts: [],
			allPurchases: [],
			refreshKey: 0,
			filterRefreshKey: 0,
			refreshLead: 0,
			actionsTemplates: [
				{
					order: 1,
					emitSlugName: "new_contract",
					buttonName: "Nouveau contrat",
					buttonIcon: "icon-plus-circle",
					buttonColor: "primary",
				},
				{
					order: 2,
					emitSlugName: "action_extract_contract",
					buttonName: "Exporter",
					buttonIcon: "icon-download-cloud",
					buttonColor: "dark",
				},
			],
			filtersTemplates: [
				{
					order: 1, // Filter order compared to others
					emitSlugName: "filter_contract",
					filterPlaceHolder: "N° de Contrat",
					value: "", // Consultant id
					type: "Input",
				},
				{
					order: 2,
					emitSlugName: "filter_client",
					filterPlaceHolder: "Client",
					value: "",
					type: "Input",
				},
				{
					order: 3,
					emitSlugName: "filter_delivery",
					filterPlaceHolder: "Prestation",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [
							{ name: "SEO", id: 1 },
							{ name: "SEA", id: 2 },
							{ name: "E-Réputation", id: 3 },
							{ name: "Social Ads", id: 4 },
							{ name: "RP Digitale", id: 5 },
							{ name: "Formation", id: 6 },
							{ name: "Autre", id: 7 },
						],
					},
				},
				{
					order: 4,
					emitSlugName: "filter_type",
					filterPlaceHolder: "Type",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [
							// {name: "Mensuel", id: 1},
							// 	{name: "One Shot", id: 0}
							//add one to avoid collision of value 0 with defaut

							{ name: "Mensuel", id: 2 },
							{ name: "One Shot", id: 1 },
						],
					},
				},
				{
					order: 5,
					emitSlugName: "filter_status",
					filterPlaceHolder: "Statut (Sélection multiple)",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: true,
						dropdownValues: [
							{ name: "Actif", id: 1 },
							{ name: "A\u00a0Valider", id: 2 },
							{ name: "A\u00a0venir", id: 8 },
							{ name: "En\u00a0pause", id: 3 },
							{ name: "Terminé", id: 4 },
							{ name: "Annulé", id: 5 },
							{ name: "Relance", id: 9 },
						],
					},
				},
				{
					order: 6,
					emitSlugName: "filter_commercial",
					filterPlaceHolder: "Commercial",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: false,
						dropdownValues: [],
					},
				},
				{
					order: 7,
					emitSlugName: "filter_consultant",
					filterPlaceHolder: "Consultant Lead",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: false,
						dropdownValues: [],
					},
				},
			],
		};
	},
	beforeRouteEnter(to, from, next) {
		// Save the previous route name in the session storage
		if (from.name) sessionStorage.setItem("prevRoute", from.name);
		next();
	},
	async created() {
		try {
			this.isLoading = true;
			this.refreshFilterList = JSON.parse(
				JSON.stringify(this.filtersTemplates)
			);
			await this.getAll();
			await this.getAllPurchaseRc();
			// this.getAllContractsWithContractsUsers()
			await this.getAllTasks();
		} catch (e) {
			this.isLoading = false;
			console.log(e);
		}
		// this.filtersTemplates[7].value = true;
	},
	mounted() {
		if (this.allCollaborators.length > 0) {
			this.createCommercialList();
			this.createAMList();
		}

		/*
		 * if(this.allContractsWithContractsUsers.length > 0){
		 * this.displayedContractsFull = this.displayContracts(this.allContractsWithContractsUsers)
		 * this.displayedContracts = this.displayedContractsFull
		 * if(sessionStorage.getItem("prevRoute") != "return_page"){
		 *   this.$router.push({ name: 'return_page' })
		 * }
		 * let contractId = sessionStorage.getItem("popupOrigin")
		 * //console.log("popup contractId", contractId)
		 * let foundContract = this.displayedContractsFull.find(contract => contract.id == contractId)
		 * if(foundContract){
		 *   this.displayContractPopup(foundContract)
		 * }
		 * sessionStorage.removeItem("popupOrigin")
		 * this.createCommercialList()
		 * this.createAMList()
		 * }
		 */
	},
	watch: {
		// displayedContracts: function () {
		// 	this.checkPopupContract();
		// },
		allContracts: function (data) {
			//console.log("run allcontracts refresh");
			this.refreshDataList = data;
			this.displayedContracts = data;
			if (
				this.$route.query.contract_id &&
				this.displayedContracts.length > 0 &&
				this.showRouterPopup
			) {
				let thisContract = this.displayedContracts.filter(
					(contract) => contract.id == this.$route.query.contract_id
				);
				this.showRouterPopup = false;
				this.displayContractPopup(thisContract[0]);
			}
			this.refreshKey++;
			this.isLoading = false;
		},
		accountmanagerFilter: function () {
			if (this.accountmanagerFilter == "") {
				this.accountmanagerFilterOn = false;
			} else {
				this.accountmanagerFilterOn = true;
			}
			this.refreshKey++;
			this.displayedContracts = this.filterContract(
				this.displayedContractsFull
			);
		},
		commercialFilter: function () {
			if (this.commercialFilter == "") {
				this.commercialFilterOn = false;
			} else {
				this.commercialFilterOn = true;
			}
			this.refreshKey++;
			this.displayedContracts = this.filterContract(
				this.displayedContractsFull
			);
		},
		deliveryFilter: function () {
			if (this.deliveryFilter == "") {
				this.deliveryFilterOn = false;
			} else {
				this.deliveryFilterOn = true;
			}
			this.refreshKey++;
			this.displayedContracts = this.filterContract(
				this.displayedContractsFull
			);
		},
		societyFilter: function () {
			if (this.societyFilter == "") {
				this.societyFilterOn = false;
			} else {
				this.societyFilterOn = true;
			}
			this.refreshKey++;
			this.displayedContracts = this.filterContract(
				this.displayedContractsFull
			);
		},
		contractNumberFilter: function () {
			if (this.contractNumberFilter == "") {
				this.contractNumberFilterOn = false;
			} else {
				this.contractNumberFilterOn = true;
			}
			this.refreshKey++;
			this.displayedContracts = this.filterContract(
				this.displayedContractsFull
			);
		},
		statusFilter: function () {
			if (this.statusFilter == "") {
				this.statusFilterOn = false;
			} else {
				this.statusFilterOn = true;
			}
			this.refreshKey++;
			this.displayedContracts = this.filterContract(
				this.displayedContractsFull
			);
		},
		typeFilter: function () {
			if (this.typeFilter == "") {
				this.typeFilterOn = false;
			} else {
				this.typeFilterOn = true;
			}
			this.refreshKey++;
			this.displayedContracts = this.filterContract(
				this.displayedContractsFull
			);
		},
		/*
		 * allContracts: function(){
		 *   this.displayedContractsFull = this.displayContracts(this.allContracts)
		 *   this.displayedContracts = this.displayedContractsFull
		 * },
		 */
		allContractsWithContractsUsers: function (data) {
			if (data.length > 0) {
				this.displayedContractsFull = this.displayContracts(data);
				this.displayedContracts = this.displayedContractsFull;
				let contractId = sessionStorage.getItem("popupOrigin");
				if (contractId) {
					//console.log("popup contractId", contractId);
					let foundContract = this.displayedContractsFull.find(
						(contract) => contract.id == contractId
					);
					if (foundContract) {
						this.displayContractPopup(foundContract);
					}
					sessionStorage.removeItem("popupOrigin");
				}
			}
		},
		allCollaborators: function (data) {
			let foundCommercialFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_commercial"
			);
			if (foundCommercialFilterId) {
				this.filtersTemplates[foundCommercialFilterId].params.dropdownValues =
					data
						.filter((collaborator) => [4, 6, 9].includes(collaborator.type))
						.sort((a, b) => {
							return a["firstname"].localeCompare(b["firstname"]); //using String.prototype.localCompare()
						})
						.map((row) => {
							return { id: row.id, name: row.firstname + " " + row.lastname };
						});
			}
			let foundConsultantFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_consultant"
			);
			if (foundConsultantFilterId) {
				this.filtersTemplates[foundConsultantFilterId].params.dropdownValues =
					data
						.filter((collaborator) => [3, 6, 7, 9].includes(collaborator.type))
						.sort((a, b) => {
							return a["firstname"].localeCompare(b["firstname"]); //using String.prototype.localCompare()
						})
						.map((row) => {
							return { id: row.id, name: row.firstname + " " + row.lastname };
						});
			}
			/*
			 * this.commercialOptions = this.sortABC(this.allCollaborators.filter(collaborator => [4, 6, 9].includes(collaborator.type)),"firstname");
			 * this.accountmanagerOptions = this.sortABC(this.allCollaborators.filter(collaborator => [3, 6, 9].includes(collaborator.type)), "firstname");
			 */
		},
	},
	computed: {
		/*
		 * allContracts: () => {
		 *   return store.state.contracts;
		 * },
		 */
		allContracts: () => {
			return store.state.contracts_contracts_users;
		},
		allSocieties: () => {
			return store.state.societies;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allContractsUsers: () => {
			return store.state.contracts_users;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allContractsWithContractsUsers: () => {
			return store.state.contracts_contracts_users;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		today: () => {
			return new Date(Date.now());
		},
		tasks: () => {
			return store.state.tasks;
		},
	},

	methods: {
		checkPopupContract() {
			if (this.$route.params.contract_id) {
				console.log("route params", this.displayedContracts);
				let thisParmasContract = this.displayedContracts.find(
					(contract) => contract.id == this.$route.params.contract_id
				);

				this.displayContractPopup(thisParmasContract);
			}
		},
		getAllPurchaseRc() {
			this.$http.get(this.apiUrl + "purchase/allrc").then((result) => {
				this.allPurchases = result.data;
			});
		},
		resetAllFilter() {
			this.accountmanagerFilter = "";
			this.commercialFilter = "";
			this.deliveryFilter = "";
			this.societyFilter = "";
			this.statusFilter = [];
			this.typeFilter = "";
			this.contractNumberFilter = "";
			this.accountmanagerFilterOn = false;
			this.commercialFilterOn = false;
			this.deliveryFilterOn = false;
			this.societyFilterOn = false;
			this.statusFilterOn = false;
			this.typeFilterOn = false;
			this.contractNumberFilterOn = false;
			this.filterContract(this.displayedContractsFull);
		},
		showContactInfoPopup(args) {
			let thisContract = this.allContracts.filter(
				(contract) => contract.id == args.contract_id
			); //sorting with contract_id
			this.displayedContracts = thisContract; //adding account_manager_avatar
			thisContract = this.displayContracts(thisContract);
			this.showContractPopup = true;
			this.displayContractPopup(thisContract[0]);
		},
		deliveryChange() {
			//console.log("changing select");
		},
		modifyPurchase(purchase) {
			//console.log("modifyPurchase");
			this.showContractPopup = false;

			// Navigate to update page
			this.$router
				.push({
					name: "update_entity",
					params: { purchaseId: purchase.id, updateEntityForm: "purchases" },
				})
				.catch((err) => {
					if (err.name !== "NavigationDuplicated") {
						console.error("Navigation error:", err);
					}
				});
		},
		renewPurchase(purchaseId) {
			//console.log("renewPurchase");
			this.showContractPopup = false;
			this.$router.push({
				name: "new_entity",
				params: { purchaseId: purchaseId, newEntityForm: "renewpurchase" },
			});
		},
		async getAll() {
			this.$store.dispatch("getAllContractsUsers").then(() => {
				//console.log("Gate's open 1");
				this.$store.dispatch("getAllSocietiesIdAndName").then(() => {
					//console.log("Gate's open 2");
					this.$store.dispatch("getAllCollaborators").then(() => {
						//console.log("Gate's open 3");
						this.$store.dispatch("getAllCollaboratorsAvatar").then(() => {
							//console.log("Gate's open 4");
							this.$store
								.dispatch("getAllContractsWithContractsUsers")
								.then(() => {
									//console.log("Gate's open 5");
								});
						});
					});
				});
			});
		},

		/**
		 * Query our API to fetch all the societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocietiesIdAndName");
		},

		/**
		 * Query our API to fetch all rankwell collaborators
		 */
		getAllCollaborators() {
			this.$store.dispatch("getAllCollaborators");
		},

		/**
		 * Query our API to fetch all the rankwell collaborators avatar
		 */
		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},

		/**
		 * Query our API to fetch all the contracts with contracts users
		 */
		getAllContractsWithContractsUsers() {
			this.$store.dispatch("getAllContractsWithContractsUsers");
		},

		/**
		 * Query our API to fetch all tasks
		 */
		getAllTasks() {
			this.$store.dispatch("getAllTasks");
		},

		/**
		 * Query our API to fetch all the contracts users
		 */
		getAllContractsUsers() {
			this.$store.dispatch("getAllContractsUsers");
		},

		createAMList() {
			let foundConsultantFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_consultant"
			);
			if (foundConsultantFilterId)
				this.filtersTemplates[foundConsultantFilterId].params.dropdownValues =
					this.sortABC(
						this.allCollaborators.filter((collaborator) =>
							[3, 6, 9].includes(collaborator.type)
						),
						"firstname"
					).map((row) => {
						return { id: row.id, name: row.firstname + " " + row.lastname };
					});
		},

		createCommercialList() {
			let foundCommercialFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_commercial"
			);
			if (foundCommercialFilterId)
				this.filtersTemplates[foundCommercialFilterId].params.dropdownValues =
					this.sortABC(
						this.allCollaborators.filter((collaborator) =>
							[4, 6, 9].includes(collaborator.type)
						),
						"firstname"
					).map((row) => {
						return { id: row.id, name: row.firstname + " " + row.lastname };
					});
		},

		isFilterSet() {
			////console.log("isFilterSet BEGIN")
			if (
				this.accountmanagerFilterOn ||
				this.commercialFilterOn ||
				this.deliveryFilterOn ||
				this.societyFilterOn ||
				this.typeFilterOn ||
				this.contractNumberFilterOn ||
				this.statusFilterOn
			)
				return true;
			return false;
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == receivedEmit[0]
			);
			if (templateRowIndex >= 0)
				this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch (receivedEmit[0]) {
				case "filter_client":
					this.societyFilter = receivedEmit[1].value;
					break;
				case "filter_contract":
					this.contractNumberFilter = receivedEmit[1].value;
					break;
				case "filter_delivery":
					this.deliveryFilter = receivedEmit[1].value;
					break;
				case "filter_type":
					this.typeFilter = receivedEmit[1].value;
					break;
				case "filter_status":
					this.statusFilter = receivedEmit[1].value;
					break;
				case "filter_commercial":
					this.commercialFilter = receivedEmit[1].value;
					break;
				case "filter_consultant":
					this.accountmanagerFilter = receivedEmit[1].value;
					break;
				default:
					break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			switch (receivedEmit[0]) {
				case "action_extract_contract":
					this.toogleExportDataPopup();
					break;
				case "new_contract":
					// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
					this.$router.push({ name: "new_entity" });
					break;
				default:
					break;
			}
		},
		/**
		 * Return list of filtered netlink A CHANGER
		 * @param {String} deliveryFilter - Type of delivery
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} contractNumberFilter - Contract Id filter
		 * @param {String} statusFilter - Contract status filter
		 * @return {List} - Societies' list filtered
		 */
		filterContract(contract) {
			let contractList = [];
			let searchKeyList = {};

			if (this.statusFilterOn) {
				searchKeyList["statusFilter"] = this.statusFilter;
			}
			if (this.deliveryFilterOn) {
				searchKeyList["deliveryFilter"] = this.deliveryFilter;
				//console.log("f" + searchKeyList["deliveryFilter"]);
			}

			this.accountmanagerFilterOn
				? (searchKeyList["accountmanagerFilter"] = this.accountmanagerFilter)
				: false;
			this.commercialFilterOn
				? (searchKeyList["commercialFilter"] = this.commercialFilter)
				: false;
			this.societyFilterOn
				? (searchKeyList["societyFilter"] = this.societyFilter
						.toLowerCase()
						.normalize("NFD")
						.replace(/[\u0300-\u036f]/g, ""))
				: false;
			this.typeFilterOn
				? (searchKeyList["typeFilter"] = parseInt(this.typeFilter) - 1)
				: false; //minus one to avoid collision of value 0 with defaut
			this.contractNumberFilterOn
				? (searchKeyList["contractNumberFilter"] = this.contractNumberFilter)
				: false;

			for (let contractToFilter of contract) {
				////console.log(netlinkToFilter)
				let society_name = contractToFilter.society_name;

				if (society_name != "") society_name = society_name.toLowerCase();

				let contractSearchKeyList = {};
				if (this.accountmanagerFilterOn) {
					if (contractToFilter.account_managers) {
						contractSearchKeyList["accountmanagerFilter"] =
							contractToFilter.account_manager_avatars
								.filter((entry) => entry.is_lead === 1)
								.map((entry) => entry.users_id);
					}
				}
				// this.accountmanagerFilterOn ? contractSearchKeyList["accountmanagerFilter"] = this.contractToFilter.account_managers  : false;
				this.commercialFilterOn
					? (contractSearchKeyList["commercialFilter"] =
							contractToFilter.commercial_id)
					: false;
				this.societyFilterOn
					? (contractSearchKeyList["societyFilter"] = society_name
							.toString()
							.normalize("NFD")
							.replace(/[\u0300-\u036f]/g, ""))
					: false;
				this.deliveryFilterOn
					? (contractSearchKeyList["deliveryFilter"] =
							contractToFilter.delivery)
					: false;
				this.contractNumberFilterOn
					? (contractSearchKeyList["contractNumberFilter"] =
							contractToFilter.id.toString())
					: false;
				this.typeFilterOn
					? (contractSearchKeyList["typeFilter"] = contractToFilter.type)
					: false;
				this.statusFilterOn
					? (contractSearchKeyList["statusFilter"] = contractToFilter.status)
					: false;

				let check = true;

				for (let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof contractSearchKeyList[key])
					 */
					if (typeof searchKeyList[key] == "string") {
						if (typeof contractSearchKeyList[key] == "string") {
							if (!contractSearchKeyList[key].includes(searchKeyList[key])) {
								check = false;
								break;
							}
						} else if (typeof contractSearchKeyList[key] == "object") {
							////console.log("Array")
							let checkLoop = false;
							for (let value of contractSearchKeyList[key]) {
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if (service_name.includes(searchKeyList[key])) {
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if (!checkLoop) {
								check = checkLoop;
								break;
							}
						}
					} else {
						if (Array.isArray(contractSearchKeyList[key])) {
							// //console.log("contractSearchKeyList[key]",contractSearchKeyList[key])
							let searchKey = searchKeyList[key];
							// //console.log(searchKey)
							let stringSearchKey = searchKey.toString();
							if (!contractSearchKeyList[key].includes(stringSearchKey)) {
								check = false;
								break;
							}
						} else {
							if (Array.isArray(searchKeyList[key])) {
								let searchKey = searchKeyList[key].map((value) => value);
								if (!searchKey.includes(contractSearchKeyList[key])) {
									check = false;
									break;
								}
							} else {
								let searchKey = searchKeyList[key];
								if (contractSearchKeyList[key] != searchKey) {
									check = false;
									break;
								}
							}
						}
					}
				}

				if (check) contractList.push(contractToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			return contractList;
		},

		/**
		 * Triggered on click
		 * Display the pop including all informations about a contract
		 */
		displayContractPopup(contract) {
			this.selectedContract = null;
			this.selectedContract = contract;
			this.showContractPopup = true;
			//console.log("inside display", contract);
			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(ContractInfoPopup);
			let contractPopup = new ComponentClass({
				propsData: {
					contract: this.selectedContract,
					popupActive: this.showContractPopup,
					router: this.$router,
					// apiUrl: this.apiUrl
				},
			});
			// @modify-contract="modifyContract($event)"
			contractPopup.$mount();
			contractPopup.$on("update-contract-data", (data) => {
				this.selectedContract = data;
			});
			contractPopup.$on("modify-contract", (contractId) => {
				this.popupActive = false;
				this.modifyContract(contractId);
			});
			contractPopup.$on("modify-missions", (contractId) => {
				this.popupActive = false;
				this.modifyMissions(contractId);
			});
			contractPopup.$on("modify-purchase", (purchase) => {
				this.popupActive = false;
				this.modifyPurchase(purchase);
			});
			contractPopup.$on("refresh-lead", () => {
				this.refreshLead++;
			});
			contractPopup.$on("renew-purchase", (purchaseId) => {
				this.popupActive = false;
				this.renewPurchase(purchaseId);
			});

			this.$refs.popupContainer.appendChild(contractPopup.$el);
		},

		displayDocumentPopup(id) {
			this.$http
				.get(this.apiUrl + "contracts_documents/list/contract/" + id)
				.then((res) => {
					if (res.data.length > 0) {
						this.showContractPopup = true;

						let ComponentClass = Vue.extend(ContractDocumentsListTable);
						let documentPopup = new ComponentClass({
							propsData: {
								contract_id: id,
								contract_documents: res.data,
								popupActive: this.showContractPopup,
							},
						});
						documentPopup.$mount();

						this.$refs.popupContainer.appendChild(documentPopup.$el);
					}
				});
		},

		modifyContract(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 0,
					updateEntityForm: "contracts",
				},
			});
		},

		modifyMissions(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 1,
					updateEntityForm: "contracts_missions",
				},
			});
		},

		removeLine(contract) {
			/*
			 * this.$vs.notify({
			 *   title: "En cours de développement",
			 *   text: "La fonctionalité sera bientôt disponible."
			 * });
			 * let contractToDelete = this.displayedContractsFull.find(element => element.id == contract.id)
			 */
			this.displayedContractsFull = this.displayedContractsFull.filter(
				function (element) {
					return element.id != contract.id;
				}
			);
			this.displayedContracts = this.displayedContractsFull;
		},

		getSocietyName(societyId) {
			let society_name = "";
			let society = this.allSocieties.find(
				(society) => society.id == societyId
			);
			/*
			 * //console.log("society")
			 * //console.log(JSON.stringify(society))
			 */
			society_name = society ? society.name : " ";
			return society_name;
		},

		getUserName(userId) {
			let user_name = "";
			/*
			 * //console.log("userId", userId)
			 * //console.log("this.allCollaborators", this.allCollaborators)
			 */
			let user = this.allCollaborators.find((user) => user.id == userId);
			user_name = user ? user.firstname + " " + user.lastname : " ";
			return user_name;
		},

		getIsLead(userId, contractId) {
			let is_lead = "";
			//Find collaborator is_lead in contract_users
			let user_contracts_list = this.allContractsUsers.filter(
				(user) => user.users_id == userId
			);
			let user = user_contracts_list.find(
				(contract) => contract.contracts_id == contractId
			);
			if (user.is_lead == 1) {
				return 1;
			}
			return is_lead;
		},

		createContractList(contracts_contracts_users) {
			let contract_id = null;
			let contract_list = [];
			let account_managers = [];
			let prec_row = null;
			for (let row of contracts_contracts_users) {
				if (contract_id == row.id) {
					account_managers.push({
						user_id: row.users_id,
						type: row.type,
						is_lead: row.is_lead,
					});
				} else {
					if (account_managers.length > 0) {
						prec_row.account_managers = JSON.parse(
							JSON.stringify(account_managers)
						);
					}

					if (prec_row == null) {
						prec_row = row;
						contract_id = row.id;
					} else {
						contract_list.push(JSON.parse(JSON.stringify(prec_row)));
						account_managers = [];
						contract_id = row.id;
						prec_row = row;
					}
				}
			}
			if (account_managers.length > 0) {
				prec_row.account_managers = JSON.parse(
					JSON.stringify(account_managers)
				);
			}
			contract_list.push(JSON.parse(JSON.stringify(prec_row)));

			return contract_list;
		},
		async getContractById(id, callback) {
			await this.$http
				.get(store.state.backendApiUrl + "contract/get/" + id)
				.then((res) => {
					callback(null, res.data[0]);
				})
				.catch((err) => {
					callback(null, null);
				});
		},

		displayContracts(contracts) {
			// let testContractList = this.createContractList(this.allContractsWithContractsUsers)
			//console.log("contract vatiable", contracts);
			try {
				let contractsList = [];
				if (this.displayedContracts.length > 0) {
					contractsList = this.displayedContracts;
				} else {
					// if(!this.isFilterSet()){
					contractsList = contracts;
					// }
				}
				//console.log("contract vatiable1", contractsList);
				if (contractsList.length > 0) {
					for (let contract of contractsList) {
						if (contract == null) {
							continue;
						}
						/*
						 *  //console.log("contract", contract)
						 *  //console.log(contract)
						 * Set society name
						 *  contract.society_name = this.getSocietyName(contract.society_id)
						 * Set commercial and account manager names (firstname + lastname)
						 *  contract.commercial_name = contract.commercial_id != null ? this.getUserName(contract.commercial_id) : " "
						 */
						let account_manager_avatars = [];
						// let account_managers_list = []
						if ("account_managers" in contract) {
							let contract_account_managers_names =
								contract.account_managers !== null
									? contract.account_managers.split(", ")
									: [];
							let contract_account_managers =
								contract_account_managers_names.splice(
									0,
									contract_account_managers_names.length / 2
								);
							for (let i = 0; i < contract_account_managers.length; i++) {
								account_manager_avatars.push({
									name: contract_account_managers_names[i],
									users_id: contract_account_managers[i],
									is_lead:
										contract.lead_am == contract_account_managers[i] ? 1 : 0,
								});
							}
							/*
							 * for(let collaborator of contract_account_managers){
							 *   account_manager_avatars.push({
							 *     name: this.getUserName(collaborator),
							 *     users_id: collaborator,
							 *     is_lead: contract.lead_am == collaborator ? 1 : 0
							 *   })
							 * }
							 */
						}
						contract.account_manager_avatars =
							account_manager_avatars.length > 0
								? account_manager_avatars
								: { name: "", is_lead: 0 };
						/*
						 * Format start and end dates
						 * Set type name
						 */
						contract.type_name = this.getContractTypeName(contract.type);
						//Set type name
						contract.delivery_name = this.getProductCategoryName(
							contract.delivery
						);
						//Set status type
					}
				}
				return contractsList;
			} catch (err) {
				//console.log("contract vatiable", err);
			}
		},

		getYearFromMonth(month) {
			let year =
				month >= 0 ? this.today.getFullYear() : this.today.getFullYear() - 1;
			return year.toString().substring(2, 4);
		},
		toogleExportDataPopup() {
			this.showExportPopup = true;
		},

		async exportData(data) {
			const invoice_options = this.getFacturationOptionList();
			const pay_delay_times = this.getFacturationDelayTime();
			const pay_types = this.getFacturationMethod();
			if (this.downloadWithMission) {
				this.$vs.loading({
					container: "#downloadButton",
					scale: 0.6,
				});
			}
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Contrats";

			let header = {
				header: [
					"id",
					"society_name",
					"delivery_name",
					"type_name",
					"status",
					"true_creation_date",
					"end_date",
					"program_end_date",
					"commercial_name",
					"contract_users_name",
					"estimate_link",
					"cumul_curr_month",
					"refac_curr_month",
					"task_curr_total",
					"task_curr_done",
					"cumul_last_month",
					"refac_last_month",
					"task_last_total",
					"task_last_done",
					"cumul_last_last_month",
					"refac_last_last_month",
					"task_last_last_total",
					"task_last_last_done",
					"max_budget",
					"max_price_netlink",
					"commentary",
					"detail",
				],
				skipHeader: true,
				origin: -1,
			};
			// Ajouter date des mois dans les header
			let formated_data = [];
			let actual_date = new Date(Date.now());
			let actual_month = actual_date.getMonth();
			let actual_year = actual_date.getFullYear();

			let date_last_month = new Date(actual_date);
			date_last_month.setMonth(actual_date.getMonth() - 1);

			let date_last_last_month = new Date(actual_date);
			date_last_last_month.setMonth(actual_date.getMonth() - 2);

			let header_names = [
				{
					id: "N° de contrat",
					society_name: "Client",
					delivery_name: "Type",
					type_name: "Mensualisation",
					status: "Statut",
					true_creation_date: "Date début",
					end_date: "Date de fin",
					program_end_date: "Date de fin programmée",
					commercial_name: "Commercial",
					contract_users_name: "Lead Consultant",
					estimate_link: "Lien devis",
					cumul_curr_month: `Montant Total ${
						actual_date.getMonth() + 1
					}/${actual_date.getFullYear()}`,
					refac_curr_month: `Montant facturable ${
						actual_date.getMonth() + 1
					}/${actual_date.getFullYear()}`,
					task_curr_total: `Tâches total ${
						actual_date.getMonth() + 1
					}/${actual_date.getFullYear()}`,
					task_curr_done: `Tâches effectuées ${
						actual_date.getMonth() + 1
					}/${actual_date.getFullYear()}`,
					cumul_last_month: `Montant Total ${
						date_last_month.getMonth() + 1
					}/${date_last_month.getFullYear()}`,
					refac_last_month: `Montant facturable  ${
						date_last_month.getMonth() + 1
					}/${date_last_month.getFullYear()}`,
					task_last_total: `Tâches total ${
						date_last_month.getMonth() + 1
					}/${date_last_month.getFullYear()}`,
					task_last_done: `Tâches effectuées ${
						date_last_month.getMonth() + 1
					}/${date_last_month.getFullYear()}`,
					cumul_last_last_month: `Montant Total ${
						date_last_last_month.getMonth() + 1
					}/${date_last_last_month.getFullYear()}`,
					refac_last_last_month: `Montant facturable  ${
						date_last_last_month.getMonth() + 1
					}/${date_last_last_month.getFullYear()}`,
					task_last_last_total: `Tâches total ${
						date_last_last_month.getMonth() + 1
					}/${date_last_last_month.getFullYear()}`,
					task_last_last_done: `Tâches effectuées ${
						date_last_last_month.getMonth() + 1
					}/${date_last_last_month.getFullYear()}`,
					max_budget: "Budget Max",
					max_price_netlink: "Prix Max du Netlink",
					commentary: "Commentaire facturation",
					detail: "Commentaire",
					facturation: "Facturation",
					pay_delay_time: "Délai des paiement",
					pay_type: "Mode de paiement",
					// account_manager_join:"Consultant",
				},
			];
			/*
			 * Ajouter account_manager_avatars.join()
			 * Ajouter mois en cours
			 * Ajouter mois dernier
			 */
			if (this.downloadWithMission) {
				////////// WITH MISSION //////////
				header_names = [
					{
						...header_names[0],
						mission_users: "Consultant(s) de la mission",
						mission_name: "Prestation",
						mission_commentary: "Commentaire Mission",
						mission_price: "Prix",
						mission_recurrence: "Presta Reccurence",
						mission_start_date: "DateDate de début",
						mission_estimated_end_date: "Date de fin estimée",
						mission_duration: "Durée de la prestation (mois)",
						mission_statut: "Statut de la mission",
						mission_price_collab: "Prix collaborateur externe",
						num_with_client: "Nombre de points avec le client",
					},
				];
				var allMission = await this.$http.get("mission/allWithProduct");
				// var allMissionUserWithName = await this.$http.get(
				// 	"mission/getmu_with_name"
				// );
			}
			///////////// PURCHASE /////////////
			for (let row of data) {
				let actualMonthSum = 0;
				let actualMonthRefac = 0;
				let lastMonthSum = 0;
				let lastMonthRefac = 0;
				let lastLastMonthSum = 0;
				let lastLastMonthRefac = 0;
				//Filtrer les achats sur le numéro de contrat
				let contract_purchases = this.allPurchases.filter(
					(purchase) => purchase.contract_id == row.id
				);

				for (let purchase of contract_purchases) {
					let purchase_date =
						purchase.recurrence > 0
							? new Date(purchase.recurrence_date)
							: new Date(purchase.bought_at);
					let purchase_month = purchase_date.getMonth();
					let purchase_year = purchase_date.getFullYear();

					if (actual_year == purchase_year && actual_month == purchase_month) {
						let totalAndRefac = this.addTotalHTAndRefac(purchase);
						actualMonthSum += totalAndRefac.total;
						actualMonthRefac += totalAndRefac.refac;
					}

					if (
						date_last_month.getFullYear() == purchase_year &&
						date_last_month.getMonth() == purchase_month
					) {
						let totalAndRefac = this.addTotalHTAndRefac(purchase);
						lastMonthSum += totalAndRefac.total;
						lastMonthRefac += totalAndRefac.refac;
					}

					if (
						date_last_last_month.getFullYear() == purchase_year &&
						date_last_last_month.getMonth() == purchase_month
					) {
						let totalAndRefac = this.addTotalHTAndRefac(purchase);
						lastLastMonthSum += totalAndRefac.total;
						lastLastMonthRefac += totalAndRefac.refac;
					}
				}
				///////////// PURCHASE /////////////

				///////////// TASKS /////////////

				let currentTasks = this.getMonthTasks(
					this.getYearFromMonth(this.today.getMonth()),
					this.today.getMonth(),
					row.id,
					this.tasks
				);
				let currentMonthTasks = currentTasks.tasks;
				let currentTaskDone = currentTasks.done;
				let currentTaskTotal = currentMonthTasks.length;

				let lastTasks = this.getMonthTasks(
					this.getYearFromMonth(this.today.getMonth() - 1),
					this.getSubstractedMonth(this.today.getMonth(), 1),
					row.id,
					this.tasks
				);
				let lastMonthTasks = lastTasks.tasks;
				let lastMonthTaskDone = lastTasks.done;
				let lastMonthTaskTotal = lastMonthTasks.length;

				let lastLastTasks = this.getMonthTasks(
					this.getYearFromMonth(this.today.getMonth() - 2),
					this.getSubstractedMonth(this.today.getMonth(), 2),
					row.id,
					this.tasks
				);
				let lastLastMonthTasks = lastLastTasks.tasks;
				let lastLastMonthTaskDone = lastLastTasks.done;
				let lastLastMonthTaskTotal = lastLastMonthTasks.length;

				///////////// TASKS /////////////
				if (this.downloadWithMission) {
					//////////// MISSIONS //////////
					//console.log(row.id);
					let missionForContract = allMission.data.filter(
						(mission) => mission.contract_id == row.id
					);
					missionForContract.forEach((mission) => {
						formated_data.push({
							id: row.id,
							delivery_name: row.delivery_name,
							commercial_name: row.commercial_name,
							mission_users: mission.mission_users_name,
							commentary: row.commentary,
							detail: row.detail,
							end_date: row.end_date
								? row.end_date.substring(0, 10).split("-").reverse().join("/")
								: null,
							program_end_date: row.program_end_date
								? row.program_end_date
										.substring(0, 10)
										.split("-")
										.reverse()
										.join("/")
								: null,
							estimate_link: row.estimate_link,
							max_budget: row.max_budget,
							max_price_netlink: row.max_price_netlink,
							society_name: row.society_name,
							true_creation_date: row.true_creation_date
								? row.true_creation_date
										.substring(0, 10)
										.split("-")
										.reverse()
										.join("/")
								: null,
							status:
								this.getContractStatus(row.status) +
								(row.status == 4
									? " (" + this.getTermineType(row.termination_reason_id) + ")"
									: ""),
							contract_users_name: mission.contract_users_name,
							type_name: row.type_name,
							cumul_curr_month: actualMonthSum,
							refac_curr_month: actualMonthRefac,
							cumul_last_month: lastMonthSum,
							facturation: invoice_options
								.filter((e) => e.id == row.invoice_period)
								.map((e) => e.name)[0],
							pay_delay_time: pay_delay_times
								.filter((e) => e.id == row.invoice_delay_time)
								.map((e) => e.name)[0],
							pay_type: pay_types
								.filter((e) => e.id == row.invoice_type)
								.map((e) => e.name)[0],
							refac_last_month: lastMonthRefac,
							cumul_last_last_month: lastLastMonthSum,
							refac_last_last_month: lastLastMonthRefac,

							task_curr_total: currentTaskTotal,
							task_curr_done: currentTaskDone,
							task_last_total: lastMonthTaskTotal,
							task_last_done: lastMonthTaskDone,
							task_last_last_total: lastLastMonthTaskTotal,
							task_last_last_done: lastLastMonthTaskDone,
							// account_manager_join:"Account manager",
							mission_name: mission.perform,
							mission_commentary: mission.short_description,
							mission_price: mission.price,
							mission_recurrence:
								mission.recurrence == 0 ? "One Shot" : "Mensuelle",
							mission_start_date: mission.start_date,
							mission_estimated_end_date: mission.estimated_end_date,
							mission_duration: mission.mission_duration,
							mission_statut: this.getContractStatus(mission.status),

							mission_price_collab: mission.provider_price_text,
							num_with_client: mission.meeting_number,
						});
					});
					//////////// MISSIONS //////////
				} else {
					//console.log(row.true_creation_date);
					const leadManager =
						row.account_manager_avatars.length > 0
							? row.account_manager_avatars.find(
									(manager) => manager.is_lead == 1
							  )
							: null;
					const contract_users_name = leadManager ? leadManager.name : null;
					formated_data.push({
						id: row.id,
						delivery_name: row.delivery_name,
						commercial_name: row.commercial_name,
						contract_users_name: contract_users_name,
						commentary: row.commentary,
						detail: row.detail,
						end_date: row.end_date
							? row.end_date.substring(0, 10).split("-").reverse().join("/")
							: null,
						program_end_date: row.program_end_date
							? row.program_end_date
									.substring(0, 10)
									.split("-")
									.reverse()
									.join("/")
							: null,
						estimate_link: row.estimate_link,
						max_budget: row.max_budget,
						max_price_netlink: row.max_price_netlink,
						society_name: row.society_name,
						true_creation_date: row.true_creation_date
							? row.true_creation_date
									.substring(0, 10)
									.split("-")
									.reverse()
									.join("/")
							: null,
						status:
							this.getContractStatus(row.status) +
							(row.status == 4 && row.termination_reason_id
								? " (" + this.getTermineType(row.termination_reason_id) + ")"
								: ""),
						type_name: row.type_name,

						cumul_curr_month: actualMonthSum,
						refac_curr_month: actualMonthRefac,
						cumul_last_month: lastMonthSum,
						refac_last_month: lastMonthRefac,
						cumul_last_last_month: lastLastMonthSum,
						refac_last_last_month: lastLastMonthRefac,
						facturation: invoice_options
							.filter((e) => e.id == row.invoice_period)
							.map((e) => e.name)[0],
						pay_delay_time: pay_delay_times
							.filter((e) => e.id == row.invoice_delay_time)
							.map((e) => e.name)[0],
						pay_type: pay_types
							.filter((e) => e.id == row.invoice_type)
							.map((e) => e.name)[0],

						task_curr_total: currentTaskTotal,
						task_curr_done: currentTaskDone,
						task_last_total: lastMonthTaskTotal,
						task_last_done: lastMonthTaskDone,
						task_last_last_total: lastLastMonthTaskTotal,
						task_last_last_done: lastLastMonthTaskDone,
						// account_manager_join:"Account manager",
					});
					// if(row.id == 720) //console.log("Contrat 720:", formated_data.length >= 1 ? formated_data[formated_data.length - 1] : "No data", row.true_creation_date);
				}
			}

			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, formated_data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Contrats_export.xls");
			this.$vs.loading.close("#downloadButton > .con-vs-loading");
			this.showExportPopup = false;
		},
	},
};
</script>

<style lang="scss">
.fw-bold {
	font-weight: bold;
	color: black;
}

.center {
	justify-content: center;
}
.lds-ellipsis {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
}
.lds-ellipsis div {
	position: absolute;
	top: 33px;
	width: 13px;
	height: 13px;
	border-radius: 50%;
	background: #08b0b9;
	animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
	left: 8px;
	animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
	left: 8px;
	animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
	left: 32px;
	animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
	left: 56px;
	animation: lds-ellipsis3 0.6s infinite;
}

.table-filter {
	.con-tablex.vs-table--content {
		.vs-con-tbody.vs-table--tbody > table {
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead {
				display: none;
			}
			tr {
				.td-check {
					width: 40px;
				}
				td {
					border: none;
				}
			}
			.tr-expand > td > div {
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table {
				display: none;
			}
		}
		.not-data-table.vs-table--not-data {
			display: none;
		}
	}
}
@keyframes lds-ellipsis1 {
	0% {
		transform: scale(0);
	}
	100% {
		transform: scale(1);
	}
}
@keyframes lds-ellipsis3 {
	0% {
		transform: scale(1);
	}
	100% {
		transform: scale(0);
	}
}
@keyframes lds-ellipsis2 {
	0% {
		transform: translate(0, 0);
	}
	100% {
		transform: translate(24px, 0);
	}
}
</style>